import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

const StyledSection = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
}));

/**
 * create room modal form skeleton
 */
export function FormSkeleton() {
    const theme = useTheme();

    return (
        <StyledWrapper>
            <StyledSection>
                <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={theme.spacing(15)} />
                <StyledSkeleton variant="rectangular" height={theme.spacing(4)} />
            </StyledSection>
            <StyledSection>
                <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={theme.spacing(15)} />
                <StyledSkeleton variant="rectangular" height={theme.spacing(15.25)} />
            </StyledSection>
            <StyledSection>
                <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={theme.spacing(15)} />
                <StyledSkeleton variant="rectangular" height={theme.spacing(4)} width={"43%"} />
            </StyledSection>
        </StyledWrapper>
    );
}

export default FormSkeleton;
